import React from "react";
import SafeAppsSDK from "@safe-global/safe-apps-sdk";

import type { SafeInfo } from "types/safe";

const isInSafeIframe = () => {
  try {
    return window.self !== window.top;
  } catch (error) {
    return false;
  }
};

export default function useSafeApps() {
  const [safeInfo, setSafeInfo] = React.useState<SafeInfo | null>(null);
  const [isSafeApp, setIsSafeApp] = React.useState(false);
  const sdkRef = React.useRef<SafeAppsSDK | null>(null);

  React.useEffect(() => {
    if (typeof window === "undefined" || !isInSafeIframe()) {
      return;
    }

    const cachedInfo = window.__MORPH_SAFE_APP__?.info;
    if (cachedInfo?.safeAddress) {
      setSafeInfo(cachedInfo);
      setIsSafeApp(true);
      return;
    }

    const sdk = sdkRef.current ?? new SafeAppsSDK();
    sdkRef.current = sdk;
    let isMounted = true;

    sdk.safe
      .getInfo()
      .then((info) => {
        if (!isMounted) {
          return;
        }
        window.__MORPH_SAFE_APP__ = { info };
        setSafeInfo(info);
        setIsSafeApp(true);
      })
      .catch(() => {
        if (!isMounted) {
          return;
        }
        setIsSafeApp(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    sdk: sdkRef.current,
    safeInfo,
    isSafeApp,
  };
}
